import { BasePaginatedUseCase } from "../../../../../common/domain/useCases/base_paginated_use_case";
import { IGetAllArquivoGenericoUseCase } from "../../../presentation/useCases/read/get_all_arquivo_generico_use_case";
import { IGetAllConfigPagamentoUseCase } from "../../../presentation/useCases/read/get_all_config_pagamento_use_case";
import { IGetAllMedicaoUseCase } from "../../../presentation/useCases/read/get_all_medicao_use_case";
import { ArquivoGenericoFilter } from "../../models/arquivo_generico_filter";
import { ArquivoGenericoLista } from "../../models/arquivo_generico_lista";
import { ConfigPagamentoFilter } from "../../models/config_pagamento_filter";
import { ConfigPagamentoLista } from "../../models/config_pagamento_lista";
import { MedicaoTerceirizacaoFilter } from "../../models/medicao_terceirizacao_filter";
import { MedicaoTerceirizacaoLista } from "../../models/medicao_terceirizacao_lista";

import { ITerceirizacaoRepository } from "../../repositories/terceirizacao_repository";


// GetAllConfigPagamentoUseCase


export class GetAllConfigPagamentoUseCase
  extends BasePaginatedUseCase<ConfigPagamentoLista>
  implements IGetAllConfigPagamentoUseCase {
  constructor(private readonly repository: ITerceirizacaoRepository) {
    super();
  }

  async getAllListagemConfigPagamento(
    filter: ConfigPagamentoFilter,
    page: number,
    rowsPerPage: number,
  ): Promise<void> {
    const response = await this.repository
      .getAllListagemConfigPagamento(
        filter,
        page,
        rowsPerPage,
      );
    
    this._items = response.items;
    this._currentPage = response.currentPage;
    this._pageSize = response.pageSize;
    this._totalItems = response.totalItems;
    this._totalPages = response.totalPages;
  }
}
